export default __webpack_public_path__ + "static/media/hidden_characters_6.ec8a32b5.png";